export default __webpack_public_path__ + "static/media/zero.cd3269f0.jpg";